

function getHistoryCell(value, key) {
  let color = (value === undefined) ? 'white' : (value === true) ? 'success' : 'danger';
  return (
    <div key={key} className='col'>
      <span className={`badge border text-bg-${color}`}>{'\u00A0'}</span>
    </div>
  );
}

/*
 * history => [(true, false), (false, false), (true, true)]
 */
function History({ history }) {
  while (history.length < 3)
    history.unshift([undefined, undefined]);

  let player_history = history.map((pair, i) => getHistoryCell(pair[0], i));
  let bot_history = history.map((pair, i) => getHistoryCell(pair[1], i));

  return (
    <div className='card col-3 text-center'>
      <h4 className='card-title py-2 border-bottom'>History</h4>
      <div className='card-body m-0 pt-3'>
        <div className='row m-3'>
          {player_history}
        </div>
        <div className='row m-3'>
          {bot_history}
        </div>
      </div>
    </div>
  );
}

export default History;
